<template>
<div>
    <b-modal id="matterConsultingFormModal" 
    ref="matterConsultingFormModal" 
    centered size="lg" 
    no-close-on-backdrop 
    :title= "$t('matter.matter_consulting')" 
    :cancel-title=" $t('others.cancel_title')" 
    :ok-title=" $t('others.ok_title')" 
    cancel-variant="outline-secondary" 
    @ok.prevent="addOrUpdate()"
    @close="clear()">
      <b-card>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="matter-consulting-law-matter-subject-input">{{ $t('matterConsulting.law_matter_subject') }}</label>
                        <b-form-group>
                            <b-form-select @change="fillRelations(lawMatterSubjectSelect)" id="matter-consulting-law-matter-subject-input" size="sm" v-model="lawMatterSubjectSelect" value-field="id" text-field="name" :options="lawMatterSubjectOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="matter-consulting-law-matter-sub-subject-input">{{ $t('matterConsulting.law_matter_sub_subject') }}</label>
                        <b-form-group>
                            <b-form-select id="matter-consulting-law-matter-sub-subject-input" size="sm" v-model="lawMatterSubSubjectSelect" value-field="id" text-field="name" :options="lawMatterSubSubjectOptions" :disabled="lawMatterSubjectSelect== 0" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="matter-consulting-opposite-side-input">{{ $t('matterConsulting.opposite_side') }}</label>
                        <b-form-group>
                            <b-form-select id="law-counter-party-input" size="sm" v-model="lawCounterPartySelect" value-field="id" text-field="name" :options="lawCounterPartyOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
                <b-col class="col-lg-6">
                    <b-form>
                        <label for="matter-matter-outcome-input">{{ $t('matterConsulting.opposite_side_attorney') }}</label>
                        <b-form-group>
                            <b-form-select id="law-counter-party-attorney-input" size="sm" v-model="lawCounterPartyAttorneySelect" value-field="id" text-field="name" :options="lawCounterPartyAttorneyOptions" />
                        </b-form-group>
                    </b-form>
                </b-col>
            </b-row>
            <b-row>
                <b-col class="col-lg-6">
                    <b-form>
                            <label>{{ $t('matter.process_result') }}</label>
                            <b-form-select size="sm" v-model="lawMatterProcessResultSelect" value-field="id" text-field="name" :options="lawMatterProcessResultOption" />
                        </b-form>
                </b-col>
            </b-row>
            <b-row>
                   <b-col class="col-lg-12">
                        <label for="payment-note-input">{{ $t('matterConsulting.note') }}</label>
                        <b-form-textarea id="matter-consulting-note-input" :placeholder=" $t('matterConsulting.note')" rows="3" v-model="note" />
                    </b-col>
            </b-row>
           </b-card>
     </b-modal>
</div>
</template>

  
<script>

export default {
    props: {
        getMatterTypeHistoryList: {
            type: Function
        },
        employeeId: {
            type: Number
        }
        
    },
    data() {
        return {
            id: 0,
            lawMatterId: 0,
            lawCounterPartyOptions: [],
            lawCounterPartySelect: 0,
            lawCounterPartyAttorneyOptions: [],
            lawCounterPartyAttorneySelect: 0,
            lawMatterSubjectOptions: [],
            lawMatterSubjectSelect: 0,
            lawMatterSubSubjectOptions: [],
            lawMatterSubSubjectSelect: 0,
            lawMatterProcessResultOption: [],
            lawMatterProcessResultSelect: 0,
            note: ''
        }
    },
    methods: {
        clear(){
            this.lawCounterPartySelect = 0
            this.lawCounterPartyAttorneySelect = 0
            this.lawMatterSubjectSelect = 0
            this.lawMatterSubSubjectSelect = 0
        },
        showConsulting(id,lawMatterId) {
            this.$refs['matterConsultingFormModal'].show()
            this.lawMatterId = lawMatterId

                this.id = id
                const data = {
                id: this.id
            }
            const controller = {
                name: 'LawMatterConsulting'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                if (response.data.resultStatus == true) {
                   this.lawCounterPartyOptions = response.data.lawCounterPartyList
                    if (this.lawCounterPartyOptions != null) {
                        this.lawCounterPartyOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawCounterPartyAttorneyOptions = response.data.lawCounterPartyAttorneyList
                    if (this.lawCounterPartyAttorneyOptions != null) {
                        this.lawCounterPartyAttorneyOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawMatterSubjectOptions = response.data.lawMatterSubjectList
                    if (this.lawMatterSubjectOptions != null) {
                        this.lawMatterSubjectOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawMatterSubSubjectOptions = response.data.lawMatterSubSubjectList
                    if (this.lawMatterSubSubjectOptions != null) {
                        this.lawMatterSubSubjectOptions.splice(0, 0, this.$nullSelected())
                    }
                    this.lawCounterPartySelect = response.data.lawMatterConsulting.lawCounterPartyId
                    this.lawCounterPartyAttorneySelect =  response.data.lawMatterConsulting.lawCounterPartyAttorneyId
                    this.lawMatterSubSubjectSelect = response.data.lawMatterConsulting.lawMatterSubSubjectId
                    this.lawMatterSubjectSelect = response.data.lawMatterConsulting.lawMatterSubjectId
                    this.note = response.data.lawMatterConsulting.note
                    this.lawMatterProcessResultOption = response.data.lawMatterProcessResultList
                    this.lawMatterProcessResultOption.splice(0, 0, this.$nullSelected())
                    this.lawMatterProcessResultSelect = response.data.lawMatterConsulting.lawMatterProcessResultId
                    
                } else {
                     this.$bvModal.hide('matterConsultingFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
            })     
        },
        async addOrUpdate() {
            const lawMatterConsultingData = {
                            id: this.id,
                            lawMatterId: this.lawMatterId,
                            lawMatterSubSubjectId : this.lawMatterSubSubjectSelect,
                            lawCounterPartyId : this.lawCounterPartySelect,
                            lawCounterPartyAttorneyId : this.lawCounterPartyAttorneySelect,
                            lawMatterProcessResultId :this.lawMatterProcessResultSelect,
                            note: this.note

                        }
            const controller = {
                name: 'LawMatterConsulting'
            }
            const payload = {
                data: lawMatterConsultingData,
                controller: controller
            }
            var response = await this.$store.dispatch('moduleAuth/save', payload)
            if (response.data.resultStatus == true) {
                if(!this.id){
                    this.id = response.data.id
                    await this.$SaveLawMatterMatterTypeHistory(2, this.id, this.lawMatterId,this.employeeId) 
                    this.getMatterTypeHistoryList()
                }
                this.$bvModal.hide('matterConsultingFormModal')
                this.$SaveAlert()
            } else {
                this.$WarningAlert(response.data.resultMessage)
            }
        },
        async fillRelations(subjectId){
           if(subjectId > 0) {
                const data = { id: parseInt(subjectId)};
                const controller = { name: 'LawMatterConsulting',actionName: 'GetLawMatterConsultingSubSubjects'}
                const payload = { data: data, controller: controller}
                const response = await  this.$store.dispatch('moduleAuth/customService', payload);
                this.lawMatterSubSubjectOptions = response.data
                if(this.lawMatterSubSubjectOptions != null ){
                    this.lawMatterSubSubjectOptions.splice(0, 0, this.$nullSelected())
                    this.lawMatterSubSubjectSelect = this.lawMatterSubSubjectOptions[0].id
                }
           }
        }
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
